export const mapSdsStatus = (isDangerousGoods, sds) => {
  if (!isDangerousGoods && !sds) {
    return 0
  } else if (isDangerousGoods && !sds) {
    return 1
  }
  return 2
}
